import algoliasearch from 'algoliasearch/lite'

/**
 * Fetches coach-hosted group program flags from the same Algolia index as
 * `CoachOfferingPrograms`. Used for profile credential tags (Jr. League / PGA HOPE)
 * when the coach has upcoming registrable programs with matching tags.
 *
 * @param {string | undefined} coachId Coach Tools `coach.id` (UUID).
 * @returns {Promise<{ hasJrLeagueProgram: boolean, hasPgaHopeProgram: boolean }>}
 */
export async function fetchCoachProgramCredentialFlags(coachId) {
  const empty = { hasJrLeagueProgram: false, hasPgaHopeProgram: false }
  if (!coachId || typeof window === 'undefined') return empty

  const appId = process.env.ALGOLIA_APP_ID
  const apiKey = process.env.ALGOLIA_API_KEY
  const indexName = process.env.ALGOLIA_GROUP_EVENTS_INDEX_NAME
  if (!appId || !apiKey || !indexName) return empty

  try {
    const searchClient = algoliasearch(appId, apiKey)
    const index = searchClient.initIndex(indexName)
    const ts = Math.floor(Date.now() / 1000)
    const filters = `coach_id:${coachId} AND registration_close_date_time_ts > ${ts} AND (tags:"PGA Jr. League" OR tags:"PGA Family Cup" OR tags:"PGA HOPE")`
    const { hits } = await index.search('', {
      filters,
      hitsPerPage: 100,
    })

    const hasJrLeagueProgram = hits.some((hit) => {
      const tags = hit.tags || []
      return tags.some((t) => t === 'PGA Jr. League' || t === 'PGA Family Cup')
    })
    const hasPgaHopeProgram = hits.some((hit) => {
      const tags = hit.tags || []
      return tags.some((t) => t === 'PGA HOPE')
    })
    return { hasJrLeagueProgram, hasPgaHopeProgram }
  } catch {
    return empty
  }
}
